export default {
  network: null,
  location: null,
  technology: null,
  legend: {},
  staticData: null,
  disclaimer: {},
  faq: [],
  currentCoverage: {},
  bounds: {},
  zoom: null,
  locationCoverage: {
    items: [],
    isOpen: false
  }
};
